import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import InputText from '../../blueprintWrappers/InputText';
import IconSmallButton from '../../blueprintWrappers/IconSmallButton';

class EditableAdditionalDetail extends Component {

	state = {
		editing: false,
		comment: ''
	}

	render() {
		const p = this.props;

		return (
			<div className={"EditableAdditionalDetail"} onKeyPress={this.handleKeyPress}>
				{this.state.editing ? this.edit() : this.show()}
			</div>
		);
	}

	handleKeyPress = (event) => {
		if (event.key == 'Enter') {
			this.toggleEditing();
		}
	}

	toggleEditing = () => {
		const p = this.props;
		this.setState({
			comment: p.value.comment,
			editing: !this.state.editing
		})
	}

	saveEdits = () => {
		const p = this.props;
		this.props.updateComment({...p.value, comment: this.state.comment});
		this.setState({
			editing: !this.state.editing
		})
	}


	onChange = (text) => {
		this.setState({
			comment: text
		})
	}

	edit = () => {
		const p = this.props;
		if (p.small) {
			return (
				<div className={"EditableDetailInputSmall"}>
					<InputText
						onChange={(text) => this.onChange(text)}
						placeholder={"..."}
						value={this.state.comment}
					/>
					<IconSmallButton
						iconName="small-tick"
						title={null}
						onClick={this.saveEdits}
					/>
				</div>
			)
		} else {
			return (
				<div className={"EditableDetailInput"}>
					<InputText
						onChange={(text) => this.onChange(text)}
						placeholder={"..."}
						value={this.state.comment}
					/>
					<IconSmallButton
						iconName="small-tick"
						title={null}
						onClick={this.saveEdits}
					/>
				</div>
			)
		}
	}

	show = () => {
		const p = this.props;

		if (p.small) {
			return (
				<div className={"EditableDetailShow"}>
					<h3>{p.value.comment}
						<IconSmallButton
							iconName="edit"
							title={null}
							onClick={this.toggleEditing}
						/>
					</h3>
				</div>
			)
		} else {
			return (
				<div >
					<h1>{p.value.comment}
						<IconSmallButton
							iconName="edit"
							title={null}
							onClick={this.toggleEditing}
						/>
					</h1>
				</div>
			)
		}

	}



}
export default EditableAdditionalDetail;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/EditableAdditionalDetail.js